import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';

import ResourceCard, { ResourceCardContentProps } from './resource-card';

const resourceCardStyling = css({
	display: 'flex',
	flexDirection: 'column',
});

const MigrationOptionsResourceCards = () => {
	const intl = useIntl();

	const startAssessmentText = intl.formatMessage({
		id: 'EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.StartAssessment',
		defaultMessage: 'Find a partner',
	});
	const learnAboutMigrationText = intl.formatMessage({
		id: 'EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.LearnAboutMigration',
		defaultMessage: 'Learn about migration',
	});
	const browseTheGuideText = intl.formatMessage({
		id: 'EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.BrowseTheGuide',
		defaultMessage: 'Browse the guide',
	});

	const migrationOptionsResourceCards: ResourceCardContentProps[] = [
		{
			header: intl.formatMessage({
				id: 'EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.MigrationAssessment',
				defaultMessage: 'Migration partners',
			}),
			description: intl.formatMessage({
				id: 'EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.MigrationAssessment.dsc',
				defaultMessage: 'Certified partners offer end-to-end 1:1 support for complex migrations.',
			}),
			buttonText: startAssessmentText,
			url: useLocalizedHref('/migration/help/find-migration-partner'),
		},
		{
			header: intl.formatMessage({
				id: 'EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.AtlassianMigration',
				defaultMessage: 'Atlassian Migration Program',
			}),
			description: intl.formatMessage({
				id: 'EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.AtlassianMigration.dsc',
				defaultMessage: 'Find tools, resources, and support to guide you through a migration.',
			}),
			buttonText: learnAboutMigrationText,
			url: useLocalizedHref('/migration'),
		},
		{
			header: intl.formatMessage({
				id: 'EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.CloudMigration',
				defaultMessage: 'Cloud migration guide',
			}),
			description: intl.formatMessage({
				id: 'EnterpriseContactPageTemplate.MigrationOptions.ResourceCard.CloudMigration.dsc',
				defaultMessage: 'Explore each phase of your migration journey with our guide.',
			}),
			buttonText: browseTheGuideText,
			url: useLocalizedHref('/migration/plan/cloud-guide'),
		},
	];

	return (
		<div css={resourceCardStyling}>
			{migrationOptionsResourceCards.map((cardProps) => (
				<ResourceCard {...cardProps} key={cardProps.header} />
			))}
		</div>
	);
};

export default MigrationOptionsResourceCards;
